<template lang="pug">
EthicLoader(v-if="state === FORM_STATES.LOADING", :lang="lang")
EthicForm(v-else-if="state === FORM_STATES.FORM", :lang="lang", :subsidiaries="subsidiaries", :enabled-file-extensions="enabledFileExtensions", :max-file-size="maxFileSize", :max-files-count="maxFilesCount", @success="onSuccess", @error="onError", :reportProcessUrl="reportProcessUrl", :reporterProtectionUrl="reporterProtectionUrl")
	template(#introduction-text)
		slot(name="introduction-text")
	template(#footer-text)
		slot(name="footer-text")
EthicSuccess(v-else-if="state === FORM_STATES.SUCCESS", :lang="lang", @back="onBack")
EthicError(v-else, :lang="lang", @back="onBack")
</template>

<script>
import { defineComponent, onMounted, ref } from '@vue/composition-api';
import EthicLoader from './components/ethic-loader.vue';
import EthicForm from './components/ethic-form.vue';
import EthicSuccess from './components/ethic-success.vue';
import EthicError from './components/ethic-error.vue';
import { FORM_STATES } from './constants';
import { useInit } from './composables/init';
import { lang } from './mixins/lang';

const enabledFileExtensions = ['.pdf', '.txt', '.doc', '.docx', '.xls', '.xlsx', '.jpg', '.jpeg', '.png', '.gif', '.tif'];
const maxFileSize = 4;
const maxFilesCount = 4;

export default defineComponent({
	mixins: [lang],
	components: {
		EthicLoader,
		EthicForm,
		EthicSuccess,
		EthicError
	},
	props: {
		reportProcessUrl: {
			type: String,
			default: 'https://otpbank.hu'
		},
		reporterProtectionUrl: {
			type: String,
			default: 'https://otpbank.hu'
		}
	},
	setup() {
		const state = ref(FORM_STATES.LOADING);
		const { subsidiaries, init } = useInit(state);
		onMounted(async () => await init());

		const onSuccess = () => (state.value = FORM_STATES.SUCCESS);
		const onError = () => (state.value = FORM_STATES.ERROR);
		const onBack = async () => {
			await init();
		};

		return { state, FORM_STATES, subsidiaries, onError, onSuccess, onBack, enabledFileExtensions, maxFileSize, maxFilesCount };
	}
});
</script>

<style src="@ui-common/vue-select/dist/vue-select.css"></style>
<style lang="sass" scoped></style>
